import { render, staticRenderFns } from "./RegisterDevice.vue?vue&type=template&id=18bbf4ae&scoped=true"
import script from "./RegisterDevice.vue?vue&type=script&lang=js"
export * from "./RegisterDevice.vue?vue&type=script&lang=js"
import style0 from "./RegisterDevice.vue?vue&type=style&index=0&id=18bbf4ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbf4ae",
  null
  
)

export default component.exports